import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Spinner, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import './DeliverySlipPage.css';
import DeliverySlipView from '../components/DeliverySlipView';

/**
 * DeliverySlipPage — Public page that renders a compact delivery slip.
 * Fetches sale data via the same public endpoint as InvoicePage.
 * Supports ?print=true query param for auto-printing on load.
 */
const DeliverySlipPage = () => {
    const { public_id } = useParams();
    const { i18n } = useTranslation();
    const { language, changeLanguage } = i18n;
    const location = useLocation();

    const [sale, setSale] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchSale = async () => {
            try {
                const response = await api.get(`/public/sales/${public_id}`);
                setSale(response.data);
            } catch (err) {
                setError('Order not found');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchSale();
    }, [public_id]);

    // Auto-print when ?print=true
    useEffect(() => {
        if (!loading && sale) {
            const queryParams = new URLSearchParams(location.search);
            if (queryParams.get('print') === 'true') {
                setTimeout(() => {
                    window.print();
                }, 400);
            }
        }
    }, [loading, sale, location.search]);

    // Set language from business settings
    useEffect(() => {
        const targetLang = sale?.business_language;
        if (targetLang && language !== targetLang) {
            changeLanguage(targetLang);
        }
    }, [sale, language, changeLanguage]);

    if (loading) {
        return <div className="delivery-slip-wrapper"><Spinner animation="border" /></div>;
    }

    if (error) {
        return <div className="delivery-slip-wrapper"><Alert variant="danger">{error}</Alert></div>;
    }

    if (!sale) return null;

    return (
        <div className="delivery-slip-wrapper">
            <DeliverySlipView sale={sale} />
        </div>
    );
};

export default DeliverySlipPage;
